module.exports = __webpack_public_path__ + "static/media/select-test-off.ec5228bb.png";